import _ from 'lodash'
import * as types from './mutations-types'
import api from './api'
import durationFormatter from '../utils/durationFormatter'
import fullDateFormatter from '../utils/fullDateFormatter'
import moment from 'moment'
import config, {backofficeUrl} from '../config'
import Papa from '../../node_modules/papaparse/papaparse'
import RondeValidator from './ronde-validator'
import dateFormatter from '../utils/dateFormatter'
import state from './state'
import {ANOMALIE_FETCH_IMAGE} from './mutations-types'

export default {

  // Login

  loginV2 ({commit}, {username, password}) {
    commit(types.LOGIN_LOADING)
    api.login(username, password)
      .then(function (res) {
        console.log(res)
        if (res.data.role === 'ADMIN') {
          commit(types.LOGIN_SUCCESS, res.data)
          localStorage.setItem('TOKEN', res.data.token)
        } else {
          commit(types.LOGIN_MESSAGE, {
            text: `Vous n'avez pas les droits d'administration`,
            type: 'danger',
          })
        }
      })
      .catch(function (err) {
        let raison
        if (err.response.data.errorMessage && err.response.data.errorMessage.includes('not found')) {
          raison = 'Impossible de vous identifier (raison : Nom d\'utilisateur incorrect)'
        } else if (err.response.data.error && err.response.data.error.includes('Bad credentials')) {
          raison = 'Impossible de vous identifier (raison : Mot de passe incorrect)'
        } else if (err.response.data.error && err.response.data.error.includes('User account is locked')) {
          raison = 'Impossible de vous identifier (raison : cet utilisateur a été désactivé)'
        } else {
          raison = 'Impossible de vous identifier (raison : Inconnue)'
        }
        commit(types.LOGIN_MESSAGE, {
          text: raison,
          type: 'danger',
        })
      })
  },
  loginWithToken ({commit}, {login}) {
    let body = {
      'login': login
    }
    commit(types.LOGIN_LOADING)
    api.fetchUserByUsername(body)
      .then(function (res) {
        console.log('res of get user :: ', res)
        if (res.data.exists) {
          commit(types.LOGIN_SUCCESS, res.data)
        } else {
          localStorage.removeItem('TOKEN')
        }
      })
      .catch(function (err) {
        console.log(err)
      })
  },
  forgotPassword ({commit}, login) {
    if (_.isEmpty(login)) {
      commit(types.LOGIN_MESSAGE, {
        text: `Veuillez renseigner un nom d'utilisateur.`,
        type: 'danger',

      })
      return
    }
    let body = {
      'login': login
    }
    api.fetchAdminEmailByLogin(body).then(function (res) {
      console.log('res :: ', res)
      if (!res.data.exists) {
        console.log('res.data.exists :: ', res.data.exists)
        commit(types.LOGIN_MESSAGE, {
          text: `Aucun administrateur n'existe avec le login (${login}).`,
          type: 'danger',
        })
        return
      }
      if (!res.data.actif) {
        console.log('res.data.exists :: ', res.data.exists)
        commit(types.LOGIN_MESSAGE, {
          text: `L'administrateur avec le login ${login} est désactivé.`,
          type: 'danger',
        })
        return
      }
      if (!res.data.email) {
        commit(types.LOGIN_MESSAGE, {
          text: `L'administrateur avec le login ${login} n'as pas d'email.`,
          type: 'danger',
        })
      } else {
        api.forgotPassword(res.data.email, res.data.id).then(function (res) {
          console.log('response mailgun => ', res)
          commit(types.LOGIN_MESSAGE, {
            text: `Un mail vient de vous être envoyé`,
            type: 'success',
          })
        }, function (err) {
          commit(types.LOGIN_MESSAGE, {
            text: `Compte existant et actif, mais une erreur est survenue (raison : ${JSON.stringify(err)})`,
            type: 'danger',
          })
        })
      }
    }, function (err) {
      console.error(err)
    })
  },
  resetPassword ({commit}, {password, confirmPassword, adminId}) {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/
    if (password !== confirmPassword) {
      commit(types.RESET_PASSWORD_MESSAGE, {
        text: `Les mots de passe ne sont pas identiques`,
        type: 'danger',
      })
      return
    }
    if (!pattern.test(password)) {
      commit(types.RESET_PASSWORD_MESSAGE, {
        text: `Impossible de modifier votre mot de passe car celui-ci n'est pas au bon format. Il doit contenir 8 caractères minimun dont : majuscules, minuscules, au moins un chiffre et un caractére spécial (@$!%*?&)`,
        type: 'danger',
      })
      return
    }
    let body = {
      'id': adminId,
      'password': password
    }
    api.updatePassword(body).then(function (res) {
      console.log(res)
      commit(types.RESET_PASSWORD_MESSAGE, {
        text: `Le mot de passe de l'administrateur a été modifié avec succès.`,
        type: 'success',
      })
      setTimeout(async () => {
        window.location.href = backofficeUrl + '/login'
      }, 3000)

    }, function (err) {
      console.log(err)
      commit(types.RESET_PASSWORD_MESSAGE, {
        text: `Impossible de modifier votre mot de passe (${err})`,
        type: 'danger',
      })
    })
  },

  // Logout

  logout ({commit}) {
    return new Promise((resolve, reject) => {
      api.logout()
        .then(function (res) {
          console.log(res)
          commit(types.LOGOUT)
          resolve()
        })
        .catch(function (err) {
          console.log('err : ', err)
          reject()
        })
    })
  },

  // Administrators

  fetchAdministratorsV2 ({commit}) {
    commit(types.CLEAR_ALL_ADMINISTRATORS)
    api.fetchAdministrators()
      .then(function (res) {
        commit(types.ADMINS_RESULT, res.data)
      }, function (err) {
        console.error(err)
      })
  },
  createAdministratorV2 ({commit}, administrator) {

    let body = {
      'nom': administrator.lastname.trim(),
      'prenom': administrator.firstname.trim(),
      'login': administrator.login.trim(),
      'email': administrator.email.trim(),
      'password': administrator.password.trim()
    }

    console.log('body ::: ', body)
    api.createAdmin(body)
      .then(function (res) {
        console.log('response create admin ::::: ', res)
        commit(types.CREATE_ADMINISTRATOR, res.data)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: 'L\'administrateur a bien été créé.',
          type: 'success',
        })
      }, function (err) {
        let raison = ''
        if (err.response.data.errorMessage && err.response.data.errorMessage.includes('A User already exists with the login')) {
          raison = `Un utilisateur avec le login  : (${administrator.login}) existe déja`
        } else if (err.response.data.errorMessage && err.response.data.errorMessage.includes('A User already exists with the email')) {
          raison = `Un utilisateur avec l'email  : (${administrator.email}) existe déja`
        } else {
          raison = err.response.data.errorMessage
        }
        console.error(err)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: raison,
          type: 'danger',
        })
      })

    /*     api.fetchUserByUsername(body).then(function (res) {
          console.log('res ::: ', res)
          if (!res.data.exists) {


          } else {
            commit(types.ADMINISTRATOR_MESSAGE, {
              text: 'Un utilisateur avec le même login existe déjà.',
              type: 'danger',
            })
          }
        }, function (err) {
          commit(types.ADMINISTRATOR_MESSAGE, {
            text: 'Une erreur est survenue. Voyez la console pour plus de détails.',
            type: 'danger',
          })
        }) */
  },
  updateAdministratorV2 ({commit}, administrator) {

    let body = {
      'nom': administrator.nom,
      'prenom': administrator.prenom,
      'email': administrator.email
    }

    console.log('admin to update ::: ', body)

    api.updateUser(administrator.id, body)
      .then(function (res) {
        commit(types.UPDATE_ADMINISTRATOR, res.data)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: 'L\'administrateur a bien été modifié.',
          type: 'success',
        })
      }, function (err) {
        let raison = ''
        if (err.response.data.errorMessage && err.response.data.errorMessage.includes('A User already exists with the email')) {
          raison = `Un utilisateur avec l'email  : (${administrator.email}) existe déja`
        } else {
          raison = err.response.data.errorMessage
        }
        console.error(err)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: raison,
          type: 'danger',
        })
      })
  },
  activateAdministratorV2 ({commit}, administrator) {
    let body = {
      'actif': true
    }
    api.updateUser(administrator.id, body)
      .then(function (res) {
        commit(types.UPDATE_ADMINISTRATOR, res.data)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: 'Le profil a bien été activé.',
          type: 'success',
        })
      }, function (err) {
        console.error(err)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: 'Une erreur est survenue. Voyez la console pour plus de détails.',
          type: 'danger',
        })
      })
  },
  deactivateAdministratorV2 ({commit}, administrator) {
    let body = {
      'actif': false
    }
    api.updateUser(administrator.id, body)
      .then(function (res) {
        commit(types.UPDATE_ADMINISTRATOR, res.data)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: 'Le profil a bien été désactivé.',
          type: 'success',
        })
      }, function (err) {
        console.error(err)
        commit(types.ADMINISTRATOR_MESSAGE, {
          text: 'Une erreur est survenue. Voyez la console pour plus de détails.',
          type: 'danger',
        })
      })
  },
  changePasswordAdministratorV2 ({commit}, {login, password, idAdmin, newPassword}) {

    console.log('login :: ', login)
    console.log('password :: ', password)
    console.log('idAdmin :: ', idAdmin)
    console.log('newPassword :: ', newPassword)

    api.login(login, password)
      .then(function (res) {
        console.log(res)
        if (res.data.role === 'ADMIN') {
          let body = {
            'password': newPassword
          }
          console.log('You can update it you are admin :: ', body)
          api.updateUser(idAdmin, body)
            .then(function (res) {
              // todo check if the password is changed for the current user if yes revoke the token and generate a new one
              commit(types.ADMINS_CHANGE_PASSWORD, {
                message: {
                  text: `Le mot de passe de l'administrateur a été modifié avec succès.`,
                  type: 'success',
                },
                updated: true
              })
            }, function (err) {
              console.error(err)
              commit(types.ADMINS_CHANGE_PASSWORD, {
                message: {
                  text: `Une erreur est survenue. Voyez la console pour plus de détails.`,
                  type: 'danger',
                },
                updated: false
              })
            })
        } else {
          console.log('You can\'t update it you are not admin')
          commit(types.ADMINS_CHANGE_PASSWORD, {
            message: {
              text: `Vous n'avez pas les droits d'administration`,
              type: 'danger',
            },
            updated: false
          })
        }
      })
      .catch(function (err) {
        let raison

        if (err.response.data.errorMessage && err.response.data.errorMessage.includes('not found')) {
          raison = 'Impossible de vous identifier (raison : Nom d\'utilisateur incorrect)'
        } else if (err.response.data.error && err.response.data.error.includes('Bad credentials')) {
          raison = 'Impossible de vous identifier (raison : Mot de passe incorrect)'
        } else if (err.response.data.error && err.response.data.error.includes('User account is locked')) {
          raison = 'Impossible de vous identifier (raison : cet utilisateur a été désactivé)'
        } else {
          raison = 'Impossible de vous identifier (raison : Inconnue)'
        }
        commit(types.ADMINS_CHANGE_PASSWORD, {
          message: {
            text: raison,
            type: 'danger',
          },
          updated: false
        })
      })
  },

  // Agents

  deactivateAgentV2 ({commit}, agent) {

    console.log('agent ::: ', agent)
    let body = {
      'actif': false
    }
    api.updateUser(agent.id, body)
      .then(function (res) {
        commit(types.UPDATE_AGENT, res.data)
        commit(types.AGENT_MESSAGE, {
          text: 'Le profil a bien été désactivé.',
          type: 'success',
        })
      }, function (err) {
        console.error(err)
        commit(types.AGENT_MESSAGE, {
          text: 'Une erreur est survenue. Voyez la console pour plus de détails.',
          type: 'danger',
        })
      })
  },
  activateAgentV2 ({commit}, agent) {
    let body = {
      'actif': true
    }

    api.updateUser(agent.id, body)
      .then(function (res) {
        commit(types.UPDATE_AGENT, res.data)
        commit(types.AGENT_MESSAGE, {
          text: 'Le profil a bien été activé.',
          type: 'success',
        })
      }, function (err) {
        console.error(err)
        commit(types.AGENT_MESSAGE, {
          text: 'Une erreur est survenue. Voyez la console pour plus de détails.',
          type: 'danger',
        })
      })
  },
  updateAgentV2 ({commit}, agent) {

    let body = {
      'nom': agent.nom,
      'prenom': agent.prenom,
      'profile': agent.profile
    }

    console.log('admin to update ::: ', body)

    api.updateUser(agent.id, body)
      .then(function (res) {
        commit(types.UPDATE_AGENT, res.data)
        commit(types.AGENT_MESSAGE, {
          text: `L'agent a bien été modifié.`,
          type: 'success',
        })
      }, function (err) {
        console.error(err)
        commit(types.UPDATE_AGENT, {
          text: 'Une erreur est survenue. Voyez la console pour plus de détails.',
          type: 'danger',
        })
      })
  },
  createAgentV2 ({commit}, agent) {

    let body = {
      'nom': agent.lastname.trim(),
      'prenom': agent.firstname.trim(),
      'login': agent.login.trim(),
      'password': agent.password.trim(),
      'profile': agent.profile
    }

    console.log('body ::: ', body)
    api.createAgent(body)
      .then(function (res) {
        console.log('response create admin ::::: ', res)
        commit(types.CREATE_AGENT, res.data)
        commit(types.AGENT_MESSAGE, {
          text: 'L\'agent a bien été créé.',
          type: 'success',
        })
      }, function (err) {
        let raison = ''
        if (err.response.data.errorMessage && err.response.data.errorMessage.includes('A User already exists with the login')) {
          raison = `Un utilisateur avec le login  : (${agent.login}) existe déja`
        } else {
          raison = err.response.data.errorMessage
        }
        console.error(err.response.data)
        commit(types.AGENT_MESSAGE, {
          text: raison,
          type: 'danger',
        })
      })
  },
  changePasswordAgentV2 ({commit}, {login, password, idAgent, newPassword}) {

    console.log('login :: ', login)
    console.log('password :: ', password)
    console.log('idAdmin :: ', idAgent)
    console.log('newPassword :: ', newPassword)

    api.login(login, password)
      .then(function (res) {
        console.log(res)
        if (res.data.role === 'ADMIN') {
          let body = {
            'password': newPassword
          }
          console.log('You can update it you are admin :: ', body)
          api.updateUser(idAgent, body)
            .then(function (res) {
              // todo check if the password is changed for the current user if yes revoke the token and generate a new one
              commit(types.AGENTS_CHANGE_PASSWORD, {
                message: {
                  text: `Le mot de passe de l'agent a été modifié avec succès.`,
                  type: 'success',
                },
                updated: true
              })
            }, function (err) {
              console.error(err)
              commit(types.AGENTS_CHANGE_PASSWORD, {
                message: {
                  text: `Une erreur est survenue. Voyez la console pour plus de détails.`,
                  type: 'danger',
                },
                updated: false
              })
            })
        } else {
          console.log('You can\'t update it you are not admin')
          commit(types.AGENTS_CHANGE_PASSWORD, {
            message: {
              text: `Vous n'avez pas les droits d'administration`,
              type: 'danger',
            },
            updated: false
          })
        }
      })
      .catch(function (err) {
        console.log('err :: ', err.response)
        let raison

        if (err.response.data.errorMessage && err.response.data.errorMessage.includes('not found')) {
          raison = 'Utilisateur Inexistant'
        } else if (err.response.data.error && err.response.data.error.includes('Bad credentials')) {
          raison = 'Mot de passe incorrect'
        }
        /*         switch (err.error) {
                  case 'Bad credentials':
                    raison = 'Nom d\'utilisateur ou mot de passe incorrect'
                    break
                  case 'disabled-credentials':
                    raison = 'Compte désactivé'
                    break
                  default:
                    raison = 'Inconnue'
                } */
        console.log('your user / password is not correct ', raison)
        commit(types.AGENTS_CHANGE_PASSWORD, {
          message: {
            text: `Impossible de vous identifier (raison : ${raison})`,
            type: 'danger',
          },
          updated: false
        })
      })
  },

  // Rondes

  fetchRondesV2 ({commit}) {
    return new Promise((resolve, reject) => {
      api.fetchRondes()
        .then(function (res) {
          console.log('rondes => ', res.data.elements)
          commit(types.RONDES_RESULT, res.data)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })
  },
  fetchAgentsV2 ({commit}) {
    return new Promise((resolve, reject) => {
      api.fetchAgents()
        .then(function (res) {
          commit(types.AGENTS_RESULT, res.data)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })
  },
  fetchAgentsList ({commit}) {
    return new Promise((resolve, reject) => {
      api.fetchAgentsList()
        .then(function (res) {
          commit(types.AGENTS_LIST_RESULT, res.data)
          console.log('done')
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })
  },
  fetchInterventionsOfRondeV2 ({commit}, {id}) {
    return new Promise((resolve, reject) => {
      api.fetchInterventions(id)
        .then(function (data) {
          commit(types.RONDE_RESULT, data.data)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })
  },
  switchInterventionsPositionsV2 ({commit}, {ronde, first, last}) {
    console.log('first => ', first)
    console.log('last => ', last)
    let interventions = []
    commit(types.RONDE_LOADING_FOR_SWITCHING_INTERVENTIONS_POSITIONS)

    if (first > last) {
      // Swap values if first is greater than last
      [first, last] = [last, first]
    }

    ronde.interventions.slice(first, last + 1).forEach(function (i, index) {
      i.order = index + first
    })
    ronde.interventions.slice(first, last + 1).forEach(function (intervention) {
      interventions.push({id: intervention.id, order: intervention.order})
    })

    api.updateInterventionsOrder(interventions)
      .then(function (res) {
        commit(types.RONDE_INTERVENTIONS_SWITCHED, ronde)
      }, function (err) {
        console.error(err)
      })
  },
  createRondeV2 ({commit}, ronde) {
    commit(types.CREATE_RONDE_LOADING)
    if (_.isEmpty(ronde.nom)) {
      commit(types.CREATE_RONDE_FINISHED, {
        message: {
          text: `Le nom d'une ronde est obligatoire.`,
          type: 'danger',
        },
        canOnlyExitModal: false,
      })
      return
    }
    api.createRonde(ronde)
      .then(function (res) {
        let newRonde = res.data
        commit(types.CREATE_RONDE_FINISHED, {
          message: {
            text: `La ronde ${ronde.nom} a bien été créée.`,
            type: 'success',
          },
          canOnlyExitModal: true,
          newRonde,
        })
      }, function (err) {
        console.error(err)
        commit(types.CREATE_RONDE_FINISHED, {
          message: {
            text: `La ronde n'a pas pu être créée : ${JSON.stringify(err)}`,
            type: 'danger',
          },
          canOnlyExitModal: false,
        })
      })
  },
  updateRondeV2 ({commit}, {ronde}) {
    if (_.isEmpty(ronde.nom)) {
      commit(types.UPDATE_RONDE_FINISHED, {
        message: {
          text: `Le nom d'une ronde est obligatoire.`,
          type: 'danger',
        },
        canOnlyExitModal: false,
      })
      return
    }
    console.log('ronde to update :: ', ronde)
    let body = {
      nom: ronde.nom,
      numero: ronde.numero,
      agentPlanifie_id: _.isEmpty(ronde.loginPla) || ronde.loginPla === '-' ? null : state.agents.data.find(i => i.login === ronde.loginPla).id,
      agentReferent_id: _.isEmpty(ronde.loginRef) || ronde.loginRef === '-' ? null : state.agents.data.find(i => i.login === ronde.loginRef).id
    }

    console.log('body => ', body)
    console.log('id => ', ronde.id)
    console.log('state => ', state.agents.data)
    api.updateRonde(ronde.id, body)
      .then(function (data) {
        console.log('data => ', data)
        let newRonde = data.data
        commit(types.UPDATE_RONDE_FINISHED, {
          message: {
            text: `La ronde ${ronde.nom} a bien été mise à jour`,
            type: 'success',
          },
          canOnlyExitModal: true,
          newRonde,
        })
      }, function (err) {
        commit(types.UPDATE_RONDE_FINISHED, {
          message: {
            text: `La ronde n'a pas pu être modifiée : ${JSON.stringify(err)}`,
            type: 'danger',
          },
          canOnlyExitModal: false,
        })
      })
  },
  addDebutOuFinJalonV2 ({commit}, {ronde, index, type}) {
    let interventions = []
    console.log('ronde : ', ronde)
    console.log('index : ', index)
    console.log('type : ', type)

    commit(types.RONDE_LOADING_FOR_SWITCHING_INTERVENTIONS_POSITIONS)
    ronde.interventions.slice(index, ronde.interventions.length + 1).forEach(function (intervention, i) {
      intervention.order = i + index + 1
    })
    ronde.interventions.slice(index, ronde.interventions.length + 1).forEach(function (intervention) {
      interventions.push({id: intervention.id, order: intervention.order})
    })

    console.log('interventions to update => ', interventions)

    api.updateInterventionsOrder(interventions)
      .then(function (res) {
        let idJalon = state.jalons.data.find(j => j.type === type).id
        let intervention = {
          order: index,
          sortieBacs: null,
          jalon_id: idJalon,
          adresse_id: null,
          ronde_id: ronde.id
        }
        api.createIntervention(intervention)
          .then(function (res) {
            console.log('res of creation :: ', res)
            ronde.interventions.splice(index, 0, res.data)
            commit(types.RONDE_INTERVENTIONS_SWITCHED, ronde)
          }, function (err) {
            console.error(err)
          })
        commit(types.RONDE_INTERVENTIONS_SWITCHED, ronde)
      }, function (err) {
        console.error(err)
      })
  },
  fetchJalonsV2 ({commit}) {
    api.fetchJalons()
      .then(function (res) {
        console.log('jalons => ', res.data.elements)
        commit(types.JALONS_RESULT, res.data)
      }, function (err) {
        console.error(err)
      })
  },
  removeInterventionV2 ({commit}, {intervention, ronde}) {
    let interventions = []
    let index = intervention.order
    console.log('ronde : ', ronde)
    console.log('intervention : ', intervention.id)
    console.log('index : ', index)

    commit(types.RONDE_LOADING_FOR_SWITCHING_INTERVENTIONS_POSITIONS)
    api.deleteIntervention(intervention.id)
      .then(function (res) {
        ronde.interventions.splice(index, 1)

        ronde.interventions.slice(index, ronde.interventions.length + 1).forEach(function (intervention, i) {
          intervention.order = i + index
        })

        ronde.interventions.slice(index, ronde.interventions.length + 1).forEach(function (intervention) {
          interventions.push({id: intervention.id, order: intervention.order})
        })

        api.updateInterventionsOrder(interventions)
          .then(function (res) {
            console.log('type :::: ', intervention.jalon)
            commit(types.RONDE_INTERVENTIONS_SWITCHED, ronde)
            if (intervention.jalon) {
              commit(types.DEBUT_FIN_JALON_REMOVED, {
                message: {
                  text: `La ligne a bien été supprimée`,
                  type: 'success',
                }
              })
            } else {
              commit(types.INTERVENTION_REMOVED, {
                message: {
                  text: `L'intervention à l'adresse ${intervention.adresse.numero} ${intervention.adresse.voie}, ${intervention.adresse.ville}, a bien été supprimée`,
                  type: 'success',
                }
              })
            }
          }, function (err) {
            console.error(err)
          })
      }, function (err) {
        console.error(err)
      })

  },
  searchAdressesV2 ({commit}, numero) {
    console.log('q :::::: ', numero)
    let body = {
      'numero': numero
    }
    commit(types.AJOUT_INTERVENTION_MODAL_SEARCHING)
    api.searchAdressesByNumero(body).then(function (res) {
      console.log('dataaaaa ::: ', res.data.elements)
      commit(types.AJOUT_INTERVENTION_MODAL_SEARCH_RESULT, res.data.elements)
    })
  },
  addInterventionV2 ({commit}, {ronde, adresse, sortieSelected, rentreeSelected, sortieIndex, rentreeIndex}) {
    var minIndex = ronde.interventions.length
    var interventions = []
    var indexesToDelete = []
    var interventionsToAdd = []
    // commit(types.AJOUT_INTERVENTION_MODAL_LOADING)
    console.log('ronde : ', ronde)
    console.log('adresse : ', adresse)
    console.log('sortieSelected : ', sortieSelected)
    console.log('rentreeSelected : ', rentreeSelected)
    console.log('sortieIndex : ', sortieIndex)
    console.log('rentreeIndex : ', rentreeIndex)

    if (sortieSelected) {
      ronde.interventions.splice(sortieIndex - 1, 0, {
        id_adresse: adresse.id,
        ordre: sortieIndex - 1,
        provisoire: true
      })

      // Get the real index of the inserted element
      const realIndex = ronde.interventions.findIndex(
        (intervention) => intervention.ordre === sortieIndex - 1
      )
      let intervention = {
        order: realIndex,
        sortieBacs: true,
        jalon_id: null,
        adresse_id: adresse.id,
        ronde_id: ronde.id
      }
      interventionsToAdd.push(intervention)
      indexesToDelete.push(realIndex)
      console.log('Real index of sortie insertion:', realIndex)
      if (realIndex < minIndex) {
        minIndex = realIndex
      }
    }
    if (rentreeSelected) {
      ronde.interventions.splice(rentreeIndex - 1, 0, {
        id_adresse: adresse.id,
        ordre: rentreeIndex - 1,
        provisoire: true
      })

      // Get the real index of the inserted element
      const realIndex = ronde.interventions.findIndex(
        (intervention) => intervention.ordre === rentreeIndex - 1
      )
      let intervention = {
        order: realIndex,
        sortieBacs: false,
        jalon_id: null,
        adresse_id: adresse.id,
        ronde_id: ronde.id
      }
      interventionsToAdd.push(intervention)
      indexesToDelete.push(realIndex)
      console.log('Real index of rentree insertion:', realIndex)
      if (realIndex < minIndex) {
        minIndex = realIndex
      }
    }

    console.log('minIndex : ', minIndex)

    ronde.interventions.slice(minIndex, ronde.interventions.length + 1).forEach(function (intervention, i) {
      intervention.order = i + minIndex
    })

    ronde.interventions.slice(minIndex, ronde.interventions.length + 1).forEach(function (intervention) {
      if (!intervention.provisoire) {
        interventions.push({id: intervention.id, order: intervention.order})
      }
    })

    console.log('ronde.interventions ::: ', ronde.interventions)
    console.log('interventions tp update ::: ', interventions)
    console.log('indexes to delete ::: ', indexesToDelete)

    indexesToDelete.forEach(function (i) {
      const index = ronde.interventions.findIndex(
        (intervention) => intervention.ordre === i
      )
      console.log(index)
      ronde.interventions.splice(index, 1)
    })
    console.log('ronde.interventions After ::: ', ronde.interventions)
    state.ronde.data.interventions = ronde.interventions

    console.log('inerventions to add :: ', interventionsToAdd)

    api.updateInterventionsOrder(interventions)
      .then(async function (res) {

        for (const intervention of interventionsToAdd) {
          try {
            const res = await api.createIntervention(intervention);
            console.log('res of creation :: ', res);
            ronde.interventions.splice(intervention.order, 0, res.data);
          } catch (err) {
            console.error(err);
          }
/*           api.createIntervention(intervention)
            .then(function (res) {
              console.log('res of creation :: ', res)
              ronde.interventions.splice(intervention.order, 0, res.data)
            }, function (err) {
              console.error(err)
            }) */
        }
        console.log("resultat => " , ronde.interventions)
        commit(types.RONDE_INTERVENTIONS_SWITCHED, ronde)
        commit(types.AJOUT_INTERVENTION_MODAL_MESSAGE, {
          message: {
            text: `L'adresse ${adresse.numero} ${adresse.voie} ${adresse.codePostal}, ${adresse.ville}, a bien été ajoutée à la ronde.`,
            type: 'success',
          },
          canOnlyExitModal: true
        })
      }, function (err) {
        console.error(err)
      })
  },
  searchTourneeOnly ({commit}, {date}) {
    console.log('gettedDate ::: ', date)
    return new Promise((resolve, reject) => {
      let body = {
        'date': date
      }
      api.fetchTourneesOnlyByDate(body)
        .then(function (res) {
          console.log('res ::: ', res)
          commit(types.MAP_RESULT,
            res.data,
          )
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })

  },
  searchTourneeOnlyForReporting ({commit}, {fromDate, toDate}) {
    console.log('debut ::: ', fromDate)
    console.log('fin ::: ', toDate)
    return new Promise((resolve, reject) => {
      let body = {
        'startDate': fromDate,
        'endDate': toDate
      }
      api.fetchTourneesOnlyByDateForReporting(body)
        .then(function (res) {
          console.log('res ::: ', res)
          commit(types.REPORTING_RESULT, res.data)
          commit(types.HIDE_REPORTING_LOADING)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })

  },
  searchTourneeForReporting ({commit}, {fromDate, toDate, agentIds, rondeIds}) {
    console.log('debut ::: ', fromDate)
    console.log('fin ::: ', toDate)
    console.log('agentIds ::: ', agentIds)
    console.log('rondeIds ::: ', rondeIds)
    return new Promise((resolve, reject) => {
      let body = {
        'startDate': fromDate,
        'endDate': toDate,
        'rondeIds': rondeIds,
        'agentIds': agentIds
      }
      api.fetchTourneesByDateForReporting(body)
        .then(function (res) {
          commit(types.REPORTING_DATA_RESULT, res.data)
          commit(types.HIDE_REPORTING_LOADING)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })

  },
  searchTournee ({commit}, {date, idRonde, idAgent}) {
    console.log('gettedDate ::: ', date)
    console.log('idRonde ::: ', idRonde)
    console.log('idAgent ::: ', idAgent)

    return new Promise((resolve, reject) => {
      let body = {
        'date': date,
        'agent_id': idAgent,
        'ronde_id': idRonde
      }
      api.fetchTournee(body)
        .then(function (res) {
          console.log('res geopassages ::: ', res)
          commit(types.GEOPASSAGES_RESULT,
            res.data,
          )
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })

  },
  validateFileFormatForImport ({commit}, rows) {
    let rondes = []
    let errorText = ''
    console.log('rows ::: ', rows)
    // check if the file starts with a ronde

    console.log(rows[0][0])
    if (rows[0][0] === null) {
      console.log('erreur')
      errorText = 'La première ligne du fichier doit contenir une ronde.<br>\n'
    }
    // check if all lines of the file are correct

    rows.forEach(function (value, index) {
      if (value[0] != null) {
        if (value[2] != null || value[3] != null || value[4] != null) {
          errorText = errorText + 'Erreur sur la ligne ' + (index + 2) + '.<br>\n'
        }
      } else if (value[2] != null) {
        if (value[0] != null || value[1] != null || value[3] != null || value[4] != null) {
          errorText = errorText + 'Erreur sur la ligne ' + (index + 2) + '.<br>\n'
        }
      } else if (value[3] != null) {
        if (value[0] != null || value[1] != null || value[2] != null || value[4] != null) {
          errorText = errorText + 'Erreur sur la ligne ' + (index + 2) + '.<br>\n'
        }
      } else if (value[4] != null) {
        if (value[0] != null || value[1] != null || value[2] != null || value[3] != null) {
          errorText = errorText + 'Erreur sur la ligne ' + (index + 2) + '.<br>\n'
        }
      }
    })

    if (errorText.length > 0) {
      commit(types.RONDES_IMPORT_MESSAGE, {
        message: {
          text: errorText,
          type: 'danger',
        },
      })

      return
    }
    // creation of rondes/interventions objects
    api.fetchAdresses()
      .then((res) => {
        commit(types.ADRESSES_RESULT, res.data)
        rows.forEach(function (value, index) {

          if (value[0] != null) {
            const ronde = {
              nom: value[0],
              numero: value[1],
              interventions: []
            }
            rondes.push(ronde)
          } else if (value[2] != null) {
            let intervention = {
              sortieBacs: null,
              jalon_id: state.jalons.data.find(jalon => jalon.type === 'Début de jalon').id,
              adresse_id: null,
            }
            rondes[rondes.length - 1].interventions.push(intervention)
          } else if (value[3] != null) {
            let foundAddress = state.adresses.data.find(adresse => adresse.id === value[3])
            if (foundAddress) {
              let interventionRentree = {
                sortieBacs: false,
                jalon_id: null,
                adresse_id: foundAddress.id,
              }
              let interventionSortie = {
                sortieBacs: true,
                jalon_id: null,
                adresse_id: foundAddress.id,
              }
              rondes[rondes.length - 1].interventions.push(interventionRentree)
              rondes[rondes.length - 1].interventions.push(interventionSortie)

            } else {
              const errorMessage = `L'id ${value[3]} est erroné : ligne (${index + 2}).<br>\n`
              errorText += errorMessage
            }
          } else if (value[4] != null) {
            let intervention = {
              sortieBacs: null,
              jalon_id: state.jalons.data.find(jalon => jalon.type === 'Fin de jalon').id,
              adresse_id: null,
            }
            rondes[rondes.length - 1].interventions.push(intervention)
          }
        })
        console.log('rondes ::  ', rondes)
        console.log('errors ::  ', errorText)

        if (errorText.length > 0) {
          commit(types.RONDES_IMPORT_MESSAGE, {
            message: {
              text: errorText,
              type: 'danger',
            },
          })

          return
        }

        rondes.forEach(function (r) {
          let order = 0
          let interventionCount = 0
          let ronde = {
            nom: r.nom,
            numero: r.numero,
            agentReferent_id: null,
            agentPlanifie_id: null
          }
          api.createRonde(ronde)
            .then(function (res) {
              ronde.id = res.data.id
              r.interventions.forEach(function (intervention) {
                if (intervention.adresse_id != null) {
                  interventionCount++
                }
                intervention.ronde_id = res.data.id
                intervention.order = order++
                api.createIntervention(intervention)
                  .then(function (res) {
                  }, function (err) {
                    console.error(err)
                  })
              })
              console.log(r.interventions)
              ronde.nbInterventions = interventionCount
              state.rondes.data.unshift(ronde)
              console.log('res of ronde :: ', res)
            }, function (err) {
              console.error(err)
            })
        })
        state.rondes.searching = false
      })
      .catch((err) => {
        console.error(err)
      })

    //  console.log('the rondes :: ', rondes)

  },

  // Anomalies

  searchAnomaliesV2 ({commit}, date) {

    let body = {
      'startDate': date.from,
      'endDate': date.to
    }
    return new Promise((resolve, reject) => {
      api.fetchAnomaliesByDates(body)
        .then(function (res) {
          commit(types.ANOMALIES_FILTER_RESULT, res.data.elements)
          console.log('res :: ', res)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })

  },
  searchAnomaliesForReportingV2 ({commit}, date) {

    let body = {
      'startDate': date.from,
      'endDate': date.to
    }
    return new Promise((resolve, reject) => {
      api.fetchAnomaliesByDates(body)
        .then(function (res) {
          commit(types.ANOMALIES_REPORTING_RESULT, res.data.elements)
          console.log('res :: ', res)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })

  },

  // Adresses

  fetchAdresses ({commit}) {
    commit(types.RONDES_SEARCHING)
    return new Promise((resolve, reject) => {
      api.fetchAdresses()
        .then(function (res) {
          commit(types.ADRESSES_RESULT, res.data)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })
  },

  // Photos

  fetchPhoto ({commit}, idPhoto) {
    return new Promise((resolve, reject) => {
      api.fetchImage(idPhoto)
        .then(function (res) {
          console.log('rondes => ', res.data.elements)
          commit(types.ANOMALIE_FETCH_IMAGE, res.data)
          resolve()
        }, function (err) {
          console.error(err)
          reject()
        })
    })
  },

  // Modals

  updateInterventionAndAdresseV2 ({commit}, {intervention, sortieDesBacs}) {
    commit(types.DETAIL_MODAL_FOR_INTERVENTION_LOADING)
    let body = {
      sortieBacs: sortieDesBacs
    }
    api.updateIntervention(intervention.id, body).then(function (res) {
      let newIntervention = res.data
      if (intervention.adresse.bacsCs < 0) {
        intervention.adresse.bacsCs = 0
      }
      if (intervention.adresse.bacsCs > 10) {

      }
      if (intervention.adresse.bacsOm < 0) {
        intervention.adresse.bacsOm = 0
      }
      if (intervention.adresse.bacsOm > 10) {

      }
      console.log(intervention.adresse.id, intervention.adresse)
      console.log('the bacsCs :: ', intervention.adresse.bacsCs)
      console.log('the bacsOm ::', intervention.adresse.bacsOm)
      api.updateAdresse(intervention.adresse.id, intervention.adresse).then(function (res) {
        let newAdresse = res.data
        commit(types.INTERVENTION_AND_ADRESSE_UPDATED, {
          message: {
            text: `L'intervention et l'adresse ${newIntervention.adresse.numero} ${newIntervention.adresse.voie}, ${newIntervention.adresse.ville}, ont bien été mises à jour`,
            type: 'success',
          },
          newIntervention,
          newAdresse
        })
      }, function (err) {
        console.error(err)
        commit(types.DETAIL_MODAL_FOR_INTERVENTION_MESSAGE, {
          text: `L'adresse de cette intervention n'a pas pu être mise à jour : ${JSON.stringify(err)}`,
          type: 'danger',
        })
      })
    }, function (err) {
      console.error(err)
      commit(types.DETAIL_MODAL_FOR_INTERVENTION_MESSAGE, {
        text: `L'intervention n'a pas pu être mise à jour : ${JSON.stringify(err)}`,
        type: 'danger',
      })
    })
  },
  showDetailModalForInterventionV2 ({commit}, intervention) {
    const preparedIntervention = _.cloneDeep(intervention)
    commit(types.SHOW_DETAIL_MODAL_FOR_INTERVENTION, _.cloneDeep(preparedIntervention))
  },
  showModalForDebutFinJalonV2 ({commit}, intervention) {
    const preparedIntervention = _.cloneDeep(intervention)
    commit(types.SHOW_DETAIL_MODAL_FOR_DEBUT_FIN_JALON, preparedIntervention)
  },
  showAjoutInterventionModalV2 ({commit}) {
    commit(types.SHOW_MODAL_FOR_AJOUT_INTERVENTION)
  },
  showRondeCreateModalV2 ({commit}) {
    commit(types.SHOW_RONDE_CREATE_MODAL)
  },
  showRondeUpdateModalV2 ({commit}) {
    commit(types.SHOW_RONDE_UPDATE_MODAL)
  },
  showRondeImportModalV2 ({commit}) {
    commit(types.SHOW_RONDE_IMPORT_MODAL)
  },
  closeRondeCreateModal ({commit}) {
    commit(types.HIDE_RONDE_CREATE_MODAL)
  },
  closeDetailModalForIntervention ({commit}) {
    commit(types.HIDE_DETAIL_MODAL_FOR_INTERVENTION)
  },
  closeAjoutInterventionModal ({commit}) {
    commit(types.HIDE_MODAL_FOR_AJOUT_INTERVENTION)
  },
  closeRondeUpdateModal ({commit}) {
    commit(types.HIDE_RONDE_UPDATE_MODAL)
  },
  closeModalForDebutFinJalonDelete ({commit}) {
    commit(types.HIDE_DETAIL_MODAL_FOR_DEBUT_FIN_JALON)
  },
  showPasswordChangeModal ({commit}) {
    commit(types.SHOW_AGENT_PASSWORD_CHANGE_MODAL)
  },
  closePasswordChangeModal ({commit}) {
    commit(types.HIDE_AGENT_PASSWORD_CHANGE_MODAL)
  },
  showAdministratorPasswordChangeModal ({commit}) {
    commit(types.SHOW_ADMINISTRATOR_PASSWORD_CHANGE_MODAL)
  },
  closeAdministratorPasswordChangeModal ({commit}) {
    commit(types.HIDE_ADMINISTRATOR_PASSWORD_CHANGE_MODAL)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js